export var valuesWikiSectionMode = ["Grid", "Swipe"];
/*

*/ 
//# sourceMappingURL=WikiSectionMode.js.map